export default __webpack_public_path__ + "static/v1_1-e238833715c61f604537282455d49166.webp";